export const loginOidc = ({ sinisterId, user_type: userType, lang } = {}) => {
  const nonce = generateNonce()
  sessionStorage.setItem('oidcStateNonce', nonce)

  const state = btoa(JSON.stringify({ nonce, sinisterId, userType, lang }))

  const params = new URLSearchParams({
    client_id: process.env.OIDC_CLIENT_ID,
    redirect_uri: `${window.location.origin}/callback`,
    response_type: 'code',
    scope: process.env.OIDC_SCOPE,
    state
  })

  window.location.assign(`${process.env.OIDC_AUTHORITY}authorize?${params.toString()}`)
}

export const parseCallbackState = (state) => {
  try {
    return JSON.parse(atob(state))
  } catch (e) {
    return null
  }
}

export const consumeStoredNonce = () => {
  const nonce = sessionStorage.getItem('oidcStateNonce')
  sessionStorage.removeItem('oidcStateNonce')
  return nonce
}

function generateNonce() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}
